$(() => {
  // enable chosen js
  $('.chosen-select').chosen({
    allow_single_deselect: true,
    no_results_text: 'No results matched',
    width: '200px',
  });

  // Chosen touch support.
  if ($('.chosen-container').length > 0) {
    $('.chosen-container').on('touchstart', function(e) {
      e.stopPropagation();
      e.preventDefault();
      // Trigger the mousedown event.
      $(this).trigger('mousedown');
    });
  }
});
